import axios from 'axios';
import { getApiAsyn, baseUrl, getApiAsynarrayBuffer } from "../../../PostAPI";
import { handleAPIError, APIError } from "../../../common/errorHandler";
import { API_URL } from "../../../../utils/constant";
import { getDecoratedUrl, decorateWithPaginationParamsPost, decorateWithSortParamsPost } from "../../../common/urlService";

const { post, put, get } = axios;

const getPayloadInfo = (res, key) => {
  if (res && res.length > 0) {
    return res.find((item) => item.filterField === key)?.query;
  }
};

const dataUploadApiForFetch = (url, data) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      authorization: localStorage.getItem("token"),
    },
  };
  return post(baseUrl + url, data, config);
};

export const fetchRateAdminAdvanceRate = async (payload) => {
  let sortdata = decorateWithSortParamsPost(payload);
  if (sortdata === "") {
    sortdata = "id,desc";
  }

  let locationId = getPayloadInfo(payload?.filters, "locationTitle");
  let categoryId = getPayloadInfo(payload?.filters, "categoryTitle");
  let startDate = getPayloadInfo(payload?.filters, "startDate");
  let endDate = getPayloadInfo(payload?.filters, "endDate");

  let pageno = decorateWithPaginationParamsPost(payload);

  const isNumericId = (val) => {
    if (val === null || val === undefined || val === '') return false;
    const num = Number(val);
    return !isNaN(num) && isFinite(num);
  };

  let payloads = {
    paged: true,
    pageNumber: pageno?.pageNumber,
    pageSize: pageno?.pageSize,
    userId: localStorage.getItem("userId"),
    sort: sortdata,
    locationId: isNumericId(locationId) ? Number(locationId) : null,
    categoryId: isNumericId(categoryId) ? Number(categoryId) : null,
    filterLocation: !isNumericId(locationId) && locationId ? locationId : null,
    filterCategory: !isNumericId(categoryId) && categoryId ? categoryId : null,
    filterStartDate: startDate || null,
    filterEndDate: endDate || null,
  };

  try {
    let result = await dataUploadApiForFetch(
      API_URL.RATEADMIN_ADVANCERATE.GET,
      payloads
    );
    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchRateAdminAdvanceRateById = async (payload) => {
  const url = API_URL.RATEADMIN_ADVANCERATE.GET_BY_ID.replace(":id", payload.id);
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));
    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchRateAdminAdvanceRateDropdown = async (payload) => {
  const url = API_URL.RATEADMIN_ADVANCERATE.DROPDOWN;
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));
    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

const dataUploadApi = (url, data, isEdit = false) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      authorization: localStorage.getItem("token"),
    },
  };
  if (isEdit) {
    return put(baseUrl + url, data, config);
  } else {
    return post(baseUrl + url, data, config);
  }
};

// Custom API for advance rate
const createAdvanceRateApi = (data) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      authorization: localStorage.getItem("token"),
    },
  };
  return post(baseUrl + API_URL.RATEADMIN_ADVANCERATE.CREATE, data, config);
};

export const createRateAdminAdvanceRate = async (payload) => {
  try {
    const { data } = await createAdvanceRateApi(payload);
    if (data?.error) {
      throw new APIError(data);
    }
    return data;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const editRateAdminAdvanceRate = async (payload) => {
  const url = API_URL.RATEADMIN_ADVANCERATE.EDIT;
  try {
    const { data } = await dataUploadApi(url, payload, true);
    if (data?.error) {
      throw new APIError(data);
    }
    return data;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const deleteRateAdminAdvanceRate = async (payload) => {
  const url = API_URL.RATEADMIN_ADVANCERATE.DELETE.replace(":id", payload.id);
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));
    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const exportRateAdminAdvanceRate = async (payload) => {
  const url = API_URL.RATEADMIN_ADVANCERATE.EXPORT;
  try {
    let result = await getApiAsynarrayBuffer(url, localStorage.getItem("token"));
    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

// Search advance rate API
const searchAdvanceRateApi = (data) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      authorization: localStorage.getItem("token"),
    },
  };
  return post(baseUrl + API_URL.RATEADMIN_ADVANCERATE.SEARCH, data, config);
};

export const searchAdvanceRate = async (payload) => {
  try {
    const { data } = await searchAdvanceRateApi(payload);
    if (data?.error) {
      throw new APIError(data);
    }
    return data;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

// Update advance rate API
const updateAdvanceRateApi = (data) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      authorization: localStorage.getItem("token"),
    },
  };
  return put(baseUrl + API_URL.RATEADMIN_ADVANCERATE.UPDATE, data, config);
};

export const updateAdvanceRate = async (payload) => {
  try {
    const { data } = await updateAdvanceRateApi(payload);
    if (data?.error) {
      throw new APIError(data);
    }
    return data;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};
